import { render, staticRenderFns } from "./SendMessageTargetType.vue?vue&type=template&id=5dba9c36&lang=pug"
import script from "./SendMessageTargetType.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports